/**
 * Группы пользователей. Влияет на пользовательский интерфейс и некоторую логику.
 * Константы продублированы с бэка: \lisa10_rest_rbac\models\ModuleConfig::GROUP_FRANCHISER
 */
export enum EGroup {
    DEALER = 'DEALER',
    FRANCHISER = 'FRANCHISER',
}
